import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../../hooks/useSelector";
import { ROLES, VIEWER_ROLES } from "../../constants/textconstants";
import { useSelector } from "react-redux";
import { usePermissions } from "../../hooks/usePermissions";
import { FEATURES } from "../../config/permissions";

const Tabs: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { can } = usePermissions();

  const allTabs = [
    { name: "Overview", path: "/", feature: FEATURES.TAB_OVERVIEW },
    { name: "Certificate Requests", path: "/all-requests/0", feature: FEATURES.TAB_CERTIFICATE_REQUESTS },
    { name: "Issued Certificates", path: "/issued-certificates", feature: FEATURES.TAB_ISSUED_CERTIFICATES },
    { name: "Assigned Booklets", path: "/assigned-certificates", feature: FEATURES.TAB_ASSIGNED_BOOKLETS },
  ];

  const tabs = allTabs.filter((tab) => can(tab.feature));

  

  return (
    <div className="tabs">
      {tabs.map((tab) => {
        let isActive = false;
        if (tab.name === "Certificate Requests") {
          isActive = location.pathname.startsWith("/all-requests") || location.pathname.startsWith("/review-request");
        } else if (tab.name === "Issued Certificates") {
          isActive = location.pathname.startsWith("/issued-certificates") || location.pathname.startsWith("/review-request");
        } else if (tab.name === "Assigned Booklets") {
          isActive = location.pathname.startsWith("/assigned-certificates");
        }
        else {
          isActive = location.pathname === tab.path;
        }

        let activeclass = isActive ? "active" : "";
        return(
        <span
          key={tab.name}
          className={tab.name === 'Overview' ? `certificate-overview-container ${activeclass}`:
          tab.name =='Issued Certificates'? `issued-certificate-container ${activeclass}`:
          tab.name == 'Assigned Booklets'? `assigned-booklets-container ${activeclass}`:  activeclass}
          onClick={() => navigate(tab.path)}
        >
          {tab.name}
        </span>
      )
      }
    )}
    </div>
  );
};

export default Tabs;
